import { SimpleGuard } from 'interfaces/guards'
import { loadRecaptchaAPIActionCreator } from 'actions/recaptchaActions'

export const recaptchaGuard: SimpleGuard = {
  name: 'Recaptcha API',
  checker: (state) => state.app.recaptcha.status === 'loaded',
  loader: (dispatch) =>
    dispatch(loadRecaptchaAPIActionCreator.request({})),
}
